<div class="date_pink_position left">
    <div class="date_pinker_range">
        <div class="tui-datepicker-input tui-datetime-input tui-has-focus">
            <input id="startpicker-input" type="text" aria-label="Date" />
            <span class="tui-ico-date"></span>
            <div id="startpicker-container"></div>
        </div>
        <span>-</span>
        <div class="tui-datepicker-input tui-datetime-input tui-has-focus">
            <input id="endpicker-input" type="text" aria-label="Date" />
            <span class="tui-ico-date"></span>
            <div id="endpicker-container"></div>
        </div>
    </div>
</div>